import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTranslation } from 'react-i18next';
import { AppLanguages } from '@shared/components/common/languages';
import { Language } from '@mui/icons-material';
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import { Menu } from '@mui/material';

type SelectLanguageProps = {
  name: string;
  label?: string;
  value?: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  margin?: 'dense' | 'normal' | 'none';
  variant?: 'icon';
};

export default function SelectLanguage({
  name,
  label,
  value,
  onChange,
  margin,
  variant,
}: SelectLanguageProps) {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  if (variant === 'icon') {
    return (
      <>
        <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
          <Language />
        </IconButton>
        <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
          {AppLanguages.map((option) => (
            <MenuItem
              key={'language-option-' + option.value}
              value={option.value}
              onClick={() =>
                onChange({
                  target: { name: 'lang', value: option.value },
                } as SelectChangeEvent<string>)
              }
            >
              {option.label}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }

  return (
    <FormControl margin={margin} fullWidth>
      <InputLabel id="select-language-input">{label ?? t('language', 'Language')}</InputLabel>
      <Select
        labelId="select-language-input"
        fullWidth
        label={label ?? t('language', 'Language')}
        name={name}
        value={value}
        onChange={onChange}
      >
        {AppLanguages.map((option) => (
          <MenuItem key={'language-option-' + option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export function SelectI18NLanguage() {
  const { i18n } = useTranslation();
  return (
    <SelectLanguage
      margin="normal"
      name="language"
      variant="icon"
      value={i18n.language}
      onChange={(event) => i18n.changeLanguage(event.target.value)}
    />
  );
}
